import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpand315: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExpand315"><Path d="M10.5 3.5H3.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 13.5V20.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.29688 4.29688L10.5 10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 13.5L19.7031 19.7031" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconExpand315;
